<template>
  <div class="relative flex min-h-screen flex-col items-center justify-center bg-gray-light bg-pattern px-6">
    <div class="relative z-10 flex flex-col items-center text-center">
      <h1 class="mb-2 text-6xl font-bold text-blue-dark">
        {{ error?.statusCode ?? 404 }}
      </h1>

      <p class="mb-2 text-xl text-gray-blue-light">
        {{ statusMessage }}
      </p>

      <p class="mb-8 max-w-md text-sm text-gray-400">
        {{ description }}
      </p>

      <UButton
        size="lg"
        color="primary"
        class="min-w-40 justify-center"
        @click="handleError"
      >
        {{ $t("error_page.back_home") }}
      </UButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { NuxtError } from "#app";

const props = defineProps<{
  error: NuxtError;
}>();

const { t } = useI18n();

const statusMessage = computed(() => {
  if (props.error?.statusCode === 404) return t("error_page.not_found_title");
  if (props.error?.statusCode === 403) return t("error_page.forbidden_title");
  if (props.error?.statusCode === 500) return t("error_page.server_error_title");
  return t("error_page.generic_title");
});

const description = computed(() => {
  if (props.error?.statusCode === 404) return t("error_page.not_found_description");
  if (props.error?.statusCode === 403) return t("error_page.forbidden_description");
  return t("error_page.generic_description");
});

const handleError = () => clearError({ redirect: "/" });
</script>
